import { subscriptionLimits } from '@/modules/base/util/constants'
import IconScanDocument from 'assets/images/icons/scan.svg'
import IconDocuments from 'assets/images/icons/doc_stack.svg'
import IconStorage from 'assets/images/icons/coins.svg'
import IllustrationScanLimit from 'assets/images/illustrations/scan-limit.svg?url'
import IllustrationFilesLimit from 'assets/images/illustrations/files-limit.svg?url'
import IllustrationStorageLimit from 'assets/images/illustrations/storage-limit.svg?url'

const getModalAssets = (limit) => {
  switch (limit) {
    case subscriptionLimits.DOCUMENT_SCAN_COUNT:
    case subscriptionLimits.DOCUMENT_SCAN_COUNT_INFO:
      return {
        icon: IconScanDocument,
        illustration: IllustrationScanLimit,
      }
    case subscriptionLimits.DOCUMENT_COUNT:
    case subscriptionLimits.DOCUMENT_COUNT_INFO:
      return {
        icon: IconDocuments,
        illustration: IllustrationFilesLimit,
      }
    case subscriptionLimits.STORAGE_SPACE:
    case subscriptionLimits.STORAGE_SPACE_INFO:
      return {
        icon: IconStorage,
        illustration: IllustrationStorageLimit,
      }
  }
}

export default getModalAssets
